/**
 * Generates a unique id at random length
 *
 * @returns {string} a unique id
 */
export default function() {
  return Math.random()
    .toString(35)
    .substr(2, 7)
}
